import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { AuthAlertContent } from "../../../app/models/features/auth/alertContent";

type AuthState = {
    errorMessage: string | null;
    alert: AuthAlertContent | null;
    // True after logout (manual or auto-on-refresh-failure). While true, useAuth skips
    // GET /session/me so a freshly-cleared cache cannot immediately re-fire the request,
    // hit 401, retrigger refresh, and loop forever. Cleared on next successful login.
    loggedOut: boolean;
};

const initialState = { errorMessage: null, alert: null, loggedOut: false } as AuthState;

const slice = createSlice({
    name: "authSlice",
    initialState,
    reducers: {
        setErrorMessage: (state, { payload }: PayloadAction<string>) => {
            state.errorMessage = payload;
        },
        setAlertContent: (state, { payload }: PayloadAction<AuthAlertContent | null>) => {
            state.alert = payload;
        },
        logout: () => ({ ...initialState, loggedOut: true }),
        sessionEstablished: (state) => {
            state.loggedOut = false;
        },
    },
});

export const { setErrorMessage, setAlertContent, logout, sessionEstablished } = slice.actions;

export default slice.reducer;

 // kept as alias for compatibility with existing store wiring; the slice itself is no longer persisted
export const authPersistedReducer = slice.reducer;

export const selectErrorMessage = (state: RootState) => state.authSlice.errorMessage;
export const selectAlertContent = (state: RootState) => state.authSlice.alert;
export const selectLoggedOut = (state: RootState) => state.authSlice.loggedOut;

